import * as angular from "angular";
import * as _ from "lodash";
import {IRootScopeService} from "angular";

export class DeliveryStopoversService {

  constructor(private $rootScope: IRootScopeService, private $task, private mapConstant) {
  }

  selectDelivery(markers, id, selected) {
    markers.forEach((marker) => {
      if (marker.serviceId === id) {
        marker.selected = selected;
        marker.setIcon(this.getMarkerIcon(marker.purpose, !marker.selected));
      }
    });
  }

  registerTaskMarkerEvents(map, marker) {
    marker.addListener('click', () => {
      this.taskClick(marker);
    });
    marker.addListener('dblclick', () => {
      this.taskDblClick(map, marker);
      this.$rootScope.$apply();
    });
  }

  taskClick(marker) {
    if (_.get(marker, 'serviceId')) {
      this.$rootScope.$emit('deliverySelected', {
        id: marker.serviceId,
        selected: !marker.selected
      });
    }
  }

  taskDblClick(map, marker) {
    map.panTo(marker.position);
  }

  deliveryTasksToMarkers(map, ids, selectedServiceIds, show, dontRegister) {
    let retVal = [];
    let maxLen = 300;

    ids.forEach((id, index) => {
      if (index > maxLen) {
        return;
      }

      let task = this.$task(id).$value();

      if (task) {
        let marker = this.taskToMarker(show ? map : null, task, selectedServiceIds[task.serviceId]);
        if (!dontRegister) {
          this.registerTaskMarkerEvents(map, marker);
        }
        retVal.push(marker);
      }
    });

    return retVal;
  }

  getMarkerIcon(purpose, unselected) {
    var height = 35;
    var width = 26;
    var index = 0;

    if (unselected) {
      index = purpose === 'Pickup' ? 0 : 4;
    } else {
      index = purpose === 'Pickup' ? 1 : 5;
    }

    return {
      url: 'assets/images/map/map_markers.png',
      scaledSize: new google.maps.Size(width * 8, height),
      size: new google.maps.Size(width, height),
      origin: new google.maps.Point(index * width, 0)
    };

  }

  getSuggestionMarkerIcon(purpose) {
    var height = 35;
    var width = 26;
    var index = purpose === 'Pickup' ? 3 : 7;

    return {
      url: 'assets/images/map/map_markers.png',
      scaledSize: new google.maps.Size(width * 8, height),
      size: new google.maps.Size(width, height),
      origin: new google.maps.Point(index * width, 0)
    };

  }

  taskToMarker(map, task, selected, doRegister?) {
    let marker = new google.maps.Marker({
      position: task.taskSpec.address.location,
      map: map,
      icon: this.getMarkerIcon(task.taskSpec.purpose, !selected),
    });

    marker.set("id", task.id || Math.floor(Math.random() * (9999 - 1 + 1)) + 1 || false);
    marker.set("serviceId", task.serviceId);
    marker.set("purpose", task.taskSpec.purpose);
    marker.set("selected", selected || false);


    if (doRegister) {
      this.registerMarkerOnClickEvent(marker, () => {
        this.$rootScope.$applyAsync(() => {
          this.$rootScope.$broadcast(this.mapConstant.events.services.selected, task.serviceId);
        });
      });
    }

    return marker;
  }

  setTaskMarker(marker, selected) {
    marker.selected = selected;
    this.setTaskMarkerIcon(marker, marker.purpose, selected);
  }

  setTaskMarkerIcon(marker, purpose, selected) {
    const icon = this.getMarkerIcon(purpose, !selected);
    marker.setIcon(icon);
  }

  registerMarkerOnClickEvent(marker, handler) {
    marker.addListener('click', handler);
  }

  taskToSuggestionMarker(map, task) {
    let marker = new google.maps.Marker({
      position: task.taskSpec.address.location,
      map: map,
      icon: this.getSuggestionMarkerIcon(task.taskSpec.purpose),
    });
    marker.set("id", task.id);
    marker.set("serviceId", task.serviceId);
    marker.set("purpose", task.taskSpec.purpose);

    return marker;

  }

  clearAll(markers) {
    markers.forEach((marker) => {
      marker.setMap(null)
    });
  }

}

angular
  .module('bringoz.admin.map')
  .service('deliveryTaskMarkersService', DeliveryStopoversService);
